import { Component, OnInit, OnDestroy, ViewChildren, QueryList, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../services/http-service.service';
import { ContentDataMap, ContentDataEditableText, ContentDataStaticText, ContentDataStreetView, ContentDataPSGeneral, ContentDataPSIBIS } from '../../model';
import { StaticTextComponent } from '../static-text/static-text.component';
import { LocationMapComponent } from '../location-map/location-map.component';
import { LocationStreetViewComponent } from '../location-street-view/location-street-view.component';
import { DistrictViewComponent } from '../district-view/district-view.component';
import { BlurbTextComponent } from '../blurb-text/blurb-text.component';
import { EditableTextComponent } from '../editable-text/editable-text.component';
import { CommonService } from '../../services/common.service';
import { saveAs } from 'file-saver/dist/FileSaver';
import { Router } from '@angular/router';
import {Subject} from 'rxjs';
import { ContentBlock, ContentBlockType, ContentResponse, Location } from '../../model';
import { District } from '../../model/content-request';
import { ContentDataDistrict, ContentDataEditableTable } from '../../model/content-block-data';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FootNote } from '../../model/prepared-statement';
import { AddBlockLocationComponent } from '../../modal/add-block-location/add-block-location.component';
import { ContentBlockTableType } from '../../model/table-type';
import { ResearchContentService } from '../../services/research-content.service';
import { BVQReportService } from 'src/app/modules/bvq/services';
import { ReportService } from 'src/app/services/report.service';
import { BVQReport } from 'src/app/model/bvq';
import { Report } from 'src/app/model';
import { LogService } from 'src/app/services';

@Component({
  selector: 'app-research-detail',
  host: {'(window:keydown)': 'hotkeys($event)'},
  templateUrl: './research-detail.component.html',
  styleUrls: ['./research-detail.component.scss']
})

export class ResearchDetailComponent implements OnInit, OnDestroy {

  @ViewChildren(StaticTextComponent) staticTextComponents:QueryList<StaticTextComponent>;
  @ViewChildren(LocationMapComponent) locationMapComponents:QueryList<LocationMapComponent>;
  @ViewChildren(LocationStreetViewComponent) locationStreetViewComponents:QueryList<LocationStreetViewComponent>;
  @ViewChildren(BlurbTextComponent) blurbTextComponents:QueryList<BlurbTextComponent>;
  @ViewChildren(DistrictViewComponent) districtViewComponents:QueryList<DistrictViewComponent>;
  @ViewChildren(EditableTextComponent) editableTextComponent:QueryList<EditableTextComponent>;

  contentResponse: ContentResponse = null;
  contentSub: any;
  loading:boolean = false;
  isShow: boolean;
  topPosToStartShowing = 210;
  ContentBlockType = ContentBlockType;
  addSectionObj: ContentBlock;
  sub: any;
  locationModal: BsModalRef;
  ContentBlockTableType = ContentBlockTableType;

  report: Report;
  currentReport: BVQReport;
  reportSub: any;
  loadingSub: any;

  constructor(
    public httpClient:HttpClient,
    public httpService:HttpService,
    private commonService:CommonService,
    private router: Router,
    private modalService: BsModalService,
    private contentService: ResearchContentService,
    public bvqReportService: BVQReportService,
    private reportService: ReportService,
    private logService : LogService
  ) {}

  @HostListener('window:scroll')
  checkScroll(): void {
    // window scroll top
    // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isShow = scrollPosition >= this.topPosToStartShowing;
  }

  ngOnInit(): void {
    // Get data From Service
    this.contentSub = this.contentService.researchContent$.subscribe(c => {
      if(c){
        this.contentResponse = c;
        if(this.contentResponse.REFS.length > 0) this.processFootnoteRef();
      }
    });

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      if(currentReport){
        this.report = currentReport;
        if (this.report.BVQ){
          this.currentReport = this.report.BVQ;
          this.bvqReportService.setReport(this.currentReport);

          if(!this.contentResponse){
            this.getContent();
          }
        }
      }
    });

    this.bvqReportService.setExpand(false);

    this.bvqReportService.setResearch(true);

    this.loadingSub = this.contentService.researchLoading$.subscribe(loading => this.loading = loading);
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    if(this.contentSub)
      this.contentSub.unsubscribe();

    if (this.reportSub)
      this.reportSub.unsubscribe();

    if(this.loadingSub)
      this.loadingSub.unsubscribe();
  }

  // updateLocationModification() - Submit location report after modification.
  updateLocationModification(): void {
    let requestObj = this.getContentRequest();
    this.loading = true;
    this.httpService.updateLocationModification({BLOCKS: requestObj.BLOCKS, EFFECTIVE_DATE: this.contentResponse.EFFECTIVE_DATE}).subscribe(response => {
      this.saveToFileSystem(response);
      this.loading = false;
    }, (error) => {
      this.loading = false;
      if (error){
      //this.toastrService.error(error.message);
      }
    });
  }

  // saveToFileSystem() - Save response to file system.
  private saveToFileSystem(response): void {
    const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    saveAs(blob, 'Research.docx');
  }

  // trackByFn() - For tracking an array item.
  trackByFn(index: any): any {
    return index;
  }

  // sortBlocks() - Sort list of blocks
  sortBlocks(): void {
    this.loading = true;
    this.contentResponse.BLOCKS.sort((a, b) => (a.ORDER > b.ORDER) ? 1 : ((b.ORDER > a.ORDER) ? -1 : 0));
    this.loading = false;
  }

  // moveUp() - move up block
  moveUp(index:number): void {
    this.contentResponse.BLOCKS[index - 1].ORDER = this.contentResponse.BLOCKS[index - 1].ORDER + 1;
    this.contentResponse.BLOCKS[index].ORDER = this.contentResponse.BLOCKS[index].ORDER - 1;
    this.sortBlocks();
  }

  // moveDown() - move down block
  moveDown(index:number): void{
    this.contentResponse.BLOCKS[index + 1].ORDER = this.contentResponse.BLOCKS[index + 1].ORDER - 1;
    this.contentResponse.BLOCKS[index].ORDER = this.contentResponse.BLOCKS[index].ORDER + 1;
    this.sortBlocks();
  }

  // duplicate() - Duplicate block
  duplicate(index:number): void{
    let duplicateItem = this.contentResponse.BLOCKS[index];
    switch(this.contentResponse.BLOCKS[index].DATA.TYPE){
    case 'EDITABLE_TEXT':
    case 'STATIC_TEXT':
      for(let i=0; i<this.staticTextComponents.length; i++){
        if(this.staticTextComponents['_results'][i].order === this.contentResponse.BLOCKS[index].ORDER){
          duplicateItem.DATA['TEXT'] = this.staticTextComponents['_results'][i].text;
        }
      }
      this.contentResponse.BLOCKS.splice(index+1, 0, JSON.parse(JSON.stringify(duplicateItem)));
      for(let i=(index+1); i<this.contentResponse.BLOCKS.length; i++){
        this.contentResponse.BLOCKS[i].ORDER = this.contentResponse.BLOCKS[i].ORDER + 1;
      }
      break;
    case 'EDITABLE_TABLE':
      for(let i=0; i<this.editableTextComponent.length; i++){
        if(this.editableTextComponent['_results'][i].order === this.contentResponse.BLOCKS[index].ORDER){
          duplicateItem.DATA['TEXT'] = this.editableTextComponent['_results'][i].text;
        }
      }
      this.contentResponse.BLOCKS.splice(index+1, 0, JSON.parse(JSON.stringify(duplicateItem)));
      for(let i=(index+1); i<this.contentResponse.BLOCKS.length; i++){
        this.contentResponse.BLOCKS[i].ORDER = this.contentResponse.BLOCKS[i].ORDER + 1;
      }
      break;
    case 'MAP':
      this.contentResponse.BLOCKS.splice(index+1, 0, JSON.parse(JSON.stringify(duplicateItem)));
      for(let i=(index+1); i<this.contentResponse.BLOCKS.length; i++){
        this.contentResponse.BLOCKS[i].ORDER = this.contentResponse.BLOCKS[i].ORDER + 1;
      }
      setTimeout(()=>{
        for(let i=0; i<this.locationMapComponents.length; i++){
          if(this.locationMapComponents['_results'][i].index === this.contentResponse.BLOCKS[index].ORDER){
            this.contentResponse.BLOCKS[index + 1].DATA['CANVAS_JSON'] = this.locationMapComponents['_results'][i].canvas.toJSON();
            this.locationMapComponents['_results'][i + 1].placesList = this.locationMapComponents['_results'][i].placesList.map(x => Object.assign({}, x));
          }
        }
      }, 2000);
      break;
    case 'DISTRICT':
      this.contentResponse.BLOCKS.splice(index+1, 0, JSON.parse(JSON.stringify(duplicateItem)));
      for(let i=(index+1); i<this.contentResponse.BLOCKS.length; i++){
        this.contentResponse.BLOCKS[i].ORDER = this.contentResponse.BLOCKS[i].ORDER + 1;
      }
      setTimeout(()=>{
        for(let i=0; i<this.districtViewComponents.length; i++){
          if(this.districtViewComponents['_results'][i].index === this.contentResponse.BLOCKS[index].ORDER){
            this.contentResponse.BLOCKS[index + 1].DATA['CANVAS_JSON'] = this.districtViewComponents['_results'][i].canvas.toJSON();
          }
        }
      }, 2000);
      break;
    case 'STREET_VIEW':
      this.contentResponse.BLOCKS.splice(index+1, 0, JSON.parse(JSON.stringify(duplicateItem)));
      for(let i=(index+1); i<this.contentResponse.BLOCKS.length; i++){
        this.contentResponse.BLOCKS[i].ORDER = this.contentResponse.BLOCKS[i].ORDER + 1;
      }
      setTimeout(()=>{
        for(let i=0; i<this.locationStreetViewComponents.length; i++){
          if(this.locationStreetViewComponents['_results'][i].index === this.contentResponse.BLOCKS[index].ORDER){
            this.contentResponse.BLOCKS[index + 1].DATA['CANVAS_JSON'] = this.locationStreetViewComponents['_results'][i].streetViewCanvas.toJSON();
            this.locationStreetViewComponents['_results'][i + 1].isStreetViewAvailable = this.locationStreetViewComponents['_results'][i].isStreetViewAvailable;
          }
        }
      }, 2000);
      break;
    case 'PREPARED_STATEMENT_IBIS':
    case 'PREPARED_STATEMENT_GENERAL':
      this.contentResponse.BLOCKS.splice(index+1, 0, JSON.parse(JSON.stringify(duplicateItem)));
      for(let i=(index+1); i<this.contentResponse.BLOCKS.length; i++){
        this.contentResponse.BLOCKS[i].ORDER = this.contentResponse.BLOCKS[i].ORDER + 1;
      }
      setTimeout(()=>{
        for(let i=0; i<this.blurbTextComponents.length; i++){
          if(this.blurbTextComponents['_results'][i].order === this.contentResponse.BLOCKS[index].ORDER){
            for(let j=0; j<this.blurbTextComponents.length; j++){
              if(this.blurbTextComponents['_results'][j].order === this.contentResponse.BLOCKS[index].ORDER + 1){
                this.blurbTextComponents['_results'][j].textAreaData = this.blurbTextComponents['_results'][i].textAreaData;
              }
            }
          }
        }
      }, 1000);
      break;
    default:
      break;
    }
  }

  // toggleMode() - Toogle mode of editable text
  toggleMode(index:number): void{
    this.contentResponse.BLOCKS[index].DATA['IS_EDIT_MODE'] = !this.contentResponse.BLOCKS[index].DATA['IS_EDIT_MODE'];
  }

  // displayCornerMenu() - Display menu in corner
  displayCornerMenu(index:number): void{
    this.contentResponse.BLOCKS[index].DATA['IS_SHOW_MENU'] = true;
  }

  // hideCornerMenu() - Hide menu in corner
  hideCornerMenu(index:number): void{
    this.contentResponse.BLOCKS[index].DATA['IS_SHOW_MENU'] = false;
  }

  // removeBlock() - Remove block from the list
  removeBlock(index:number): void{
    this.contentResponse.BLOCKS.splice(index, 1);
    for(let i=(index); i<this.contentResponse.BLOCKS.length; i++){
      this.contentResponse.BLOCKS[i].ORDER = this.contentResponse.BLOCKS[i].ORDER - 1;
    }
  }

  // gotoTop() - Go to up while scrolling
  gotoTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  // addAnotherBlurbBlock() - Add another blurb block
  addAnotherBlurbBlock(index:number): void{
    this.contentResponse.BLOCKS.splice(index + 1, 0, JSON.parse(JSON.stringify(this.contentResponse.BLOCKS[index])));
    this.contentResponse.BLOCKS.join();
  }

  // preventClick() - Prevent click event of selecting row
  preventClick(event): void{
    event.stopPropagation();
  }

  // updateFTRef() - Update footnote reference array when list gets changed.
  updateFTRef(ft_notes:FootNote[]): void{
    ft_notes.forEach(item => {
      let isExist:boolean = false;
      this.contentResponse.REFS.forEach(ftNote => {
        if(ftNote.CODE === item.CODE) isExist = true;
      });
      if(!isExist) this.contentResponse.REFS.push(item);
    });
  }

  // processFootnoteRef() - process static footnote reference.
  processFootnoteRef(): void{
    let matchString = '';
    this.contentResponse.REFS.map((note, index) => {
      matchString += '<sup>' + note.CODE + '</sup>';
      if(index !== this.contentResponse.REFS.length - 1) matchString += '|';
    });
    let regex = new RegExp(matchString, 'g' );

    this.contentResponse.BLOCKS.map((item)=>{
      if(item.DATA.TYPE === 'STATIC_TEXT' || item.DATA.TYPE === 'EDITABLE_TEXT'){
        let formatText = item.DATA['TEXT'];

        let footnoteList = (formatText.match(regex) || []);
        if(footnoteList.length > 0){
          footnoteList.map((footnote, footNoteIndex) => {
            let footnoteCode = footnote.replace('<sup>', '');
            footnoteCode = footnoteCode.replace('</sup>', '');
            let refernceData:FootNote;
            this.contentResponse.REFS.map((footNoteitem:FootNote) => {
              if(footNoteitem.CODE === footnoteCode){
                refernceData = footNoteitem;
              }
            });
            let supReplaceText = '<sup><a class="sup_footnote_reference_tooltip" onclick="document.getElementById(\'' + footnoteCode + '\').scrollIntoView()">' + footnoteCode + '<span class="actual_footnote_tooltip">' + refernceData.REFERENCE + '</span></a></sup>';
            item.DATA['TEXT'] = item.DATA['TEXT'].replace(footnoteList[footNoteIndex], supReplaceText);
          });
        }
      }
    });
  }

  // editableTableChange() - Update value according to table change.
  editableTableChange(event, i): void{
    this.contentResponse.BLOCKS[i].DATA['TEXT'] = event['TEXT'];
    this.contentResponse.BLOCKS[i].DATA['COLUMNS'] = event['COLUMNS'];
  }

  /** Highlight All sections */
  highlightSection(type: ContentBlockType, tableType: ContentBlockTableType = null): void{
    switch (type) {
    case ContentBlockType.PREPARED_STATEMENT_GENERAL:
    case ContentBlockType.PREPARED_STATEMENT_IBIS:
    case ContentBlockType.EDITABLE_TEXT:
      this.addSectionObj = new ContentBlock({DATA: {TYPE: type}});
      this.contentResponse.HIGHLIGHT_BLOCKS = true;
      break;
    case ContentBlockType.EDITABLE_TABLE:
      this.addSectionObj = new ContentBlock({DATA: {
        TYPE: type,
        TABLE_TYPE: tableType,
        TEXT: '',
        COLUMNS: []
      }});
      this.contentResponse.HIGHLIGHT_BLOCKS = true;
      break;
    case ContentBlockType.MAP:
    case ContentBlockType.STREET_VIEW:
      this.openAddLocationModal(type);
      break;
    default:
      break;
    }
  }

  /** Open modal to add new block of map or location */
  openAddLocationModal(type: ContentBlockType): void{
    this.locationModal = this.modalService.show(AddBlockLocationComponent, {backdrop: 'static'});
    const ackSubject = new Subject<any>();
    this.locationModal.content.subject = ackSubject;

    ackSubject.subscribe(location => {
      if (location) {
        let obj = {DATA: {LOCATION: location, TYPE: type}};
        this.addSectionObj = new ContentBlock(obj);
        this.contentResponse.HIGHLIGHT_BLOCKS = true;
      }
    });
  }

  /** Add Section */
  addSection(index: number): void{
    this.addSectionObj.ORDER = this.contentResponse.BLOCKS[index].ORDER + 1;
    for(let i=(index+1); i<this.contentResponse.BLOCKS.length; i++){
      this.contentResponse.BLOCKS[i].ORDER += 1;
    }
    this.contentResponse.BLOCKS.push(this.addSectionObj);
    this.sortBlocks();

    this.addSectionObj = null;
    this.contentResponse.HIGHLIGHT_BLOCKS = false;
  }

  /** If we are highlighting block to edit, click `esc` to cancel */
  hotkeys(event): void {
    if (event.keyCode == 27 && this.contentResponse.HIGHLIGHT_BLOCKS){
      this.addSectionObj = null;
      this.contentResponse.HIGHLIGHT_BLOCKS = false;
    }
  }

  /** Save updated data */
  onSave(): void {
    let requestObj: ContentResponse = this.getContentRequest();
    requestObj.EFFECTIVE_DATE = this.contentResponse.EFFECTIVE_DATE
    requestObj.HIGHLIGHT_BLOCKS = this.contentResponse.HIGHLIGHT_BLOCKS;
    requestObj.PS_GENERAL = this.contentResponse.PS_GENERAL;
    requestObj.PS_IBIS = this.contentResponse.PS_IBIS;
    requestObj.REFS = this.contentResponse.REFS;

    this.loading = true;
    this.logService.log(requestObj)
    this.httpService.saveContent(this.report.ID, requestObj)
      .subscribe(data => {
      if(data.success){
        this.logService.log("success");
      }
      this.loading = false;
    }, (error) => {
      this.logService.error(error);
      this.loading = false;
    });
  }

  /** Get research content */
  getContent(): void {
    this.loading = true;
    this.httpService.getResearchContent(this.report.ID)
      .subscribe(data => {
        if(data.success){
          if(data.result){
            console.clear();
            console.log(data.result);
            this.contentResponse = new ContentResponse(data.result);
            this.contentService.setContent(this.contentResponse);
          }
        }
        this.loading = false;
      }, () => {
        this.loading = false;
      });
  }

  /** Get content request object to submit in request */
  getContentRequest(): any {
    let requestObj = new ContentResponse();
    for(let i=0; i<this.contentResponse.BLOCKS.length; i++){

      switch(this.contentResponse.BLOCKS[i].DATA.TYPE){
      case ContentBlockType.EDITABLE_TEXT:
        let contentDataEditableText = new ContentDataEditableText();
        for(let j=0; j<this.staticTextComponents.length;j++){
          if(this.staticTextComponents['_results'][j].order === this.contentResponse.BLOCKS[i].ORDER){
            contentDataEditableText.TEXT = this.staticTextComponents['_results'][j].text;
            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataEditableText, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      case ContentBlockType.STATIC_TEXT:
        let contentDataStaticText = new ContentDataStaticText();
        for(let j=0; j<this.staticTextComponents.length;j++){
          if(this.staticTextComponents['_results'][j].order === this.contentResponse.BLOCKS[i].ORDER){
            contentDataStaticText.TEXT = this.staticTextComponents['_results'][j].text;
            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataStaticText, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      case ContentBlockType.MAP:
        let contentDataMap = new ContentDataMap();
        for(let j=0; j<this.locationMapComponents.length;j++){
          if(this.locationMapComponents['_results'][j].index === this.contentResponse.BLOCKS[i].ORDER){
            let location = new Location();
            location.ADDRESS = this.locationMapComponents['_results'][j].locationInfo.ADDRESS;
            location.CITY = this.locationMapComponents['_results'][j].locationInfo.CITY;
            location.STATE = this.locationMapComponents['_results'][j].locationInfo.STATE;
            location.ZIP = this.locationMapComponents['_results'][j].locationInfo.ZIP;

            contentDataMap.LOCATION = location;
            contentDataMap.IMAGE_DATA = this.locationMapComponents['_results'][j].canvas.toDataURL();
            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataMap, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      case ContentBlockType.STREET_VIEW:
        let contentDataStreetView = new ContentDataStreetView();
        for(let j=0; j<this.locationStreetViewComponents.length;j++){
          if(this.locationStreetViewComponents['_results'][j].index === this.contentResponse.BLOCKS[i].ORDER){
            let location = new Location();
            location.ADDRESS = this.locationStreetViewComponents['_results'][j].locationInfo.ADDRESS;
            location.CITY = this.locationStreetViewComponents['_results'][j].locationInfo.CITY;
            location.STATE = this.locationStreetViewComponents['_results'][j].locationInfo.STATE;
            location.ZIP = this.locationStreetViewComponents['_results'][j].locationInfo.ZIP;

            contentDataStreetView.LOCATION = location;
            contentDataStreetView.IMAGE_DATA = this.locationStreetViewComponents['_results'][j].streetViewCanvas.toDataURL();

            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataStreetView, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      case ContentBlockType.PREPARED_STATEMENT_IBIS:
        let contentDataPSIBIS = new ContentDataPSIBIS();
        for(let j=0; j<this.blurbTextComponents.length;j++){
          if(this.blurbTextComponents['_results'][j].order === this.contentResponse.BLOCKS[i].ORDER){
            contentDataPSIBIS.TEXT = this.blurbTextComponents['_results'][j].textAreaData;
            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataPSIBIS, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      case ContentBlockType.PREPARED_STATEMENT_GENERAL:
        let contentDataPSGeneral= new ContentDataPSGeneral();
        for(let j=0; j<this.blurbTextComponents.length;j++){
          if(this.blurbTextComponents['_results'][j].order === this.contentResponse.BLOCKS[i].ORDER){
            contentDataPSGeneral.TEXT = this.blurbTextComponents['_results'][j].textAreaData;
            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataPSGeneral, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      case ContentBlockType.EDITABLE_TABLE:
        let contentDataEditableTable = new ContentDataEditableTable();
        contentDataEditableTable.COLUMNS = this.contentResponse.BLOCKS[i].DATA['COLUMNS'];
        for(let j=0; j<this.editableTextComponent.length;j++){
          if(this.editableTextComponent['_results'][j].order === this.contentResponse.BLOCKS[i].ORDER){
            contentDataEditableTable.TEXT = this.editableTextComponent['_results'][j].text;
            contentDataEditableTable.TABLE_TYPE = this.editableTextComponent['_results'][j].tableType;
            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataEditableTable, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      case ContentBlockType.DISTRICT:
        let contentDataDistrict = new ContentDataDistrict();
        for(let j=0; j<this.districtViewComponents.length;j++){
          if(this.districtViewComponents['_results'][j].index === this.contentResponse.BLOCKS[i].ORDER){

            this.districtViewComponents['_results'][j].placesList.map((place, pi) => {
              if(place.IS_MARKED){
                let district = new District();
                district.NAME = place.PLACE.name;
                district.ADDRESS = place.PLACE.formatted_address;
                district.NUMBER = place.NUMBER;
                district.RATING = place.RATING;
                district.WEB = place.WEBSITE;
                district.ID = pi + 1;

                if(!contentDataDistrict.POI)
                  contentDataDistrict.POI = [];

                contentDataDistrict.POI.push(district);
              }
            });

            contentDataDistrict.IMAGE_DATA = this.districtViewComponents['_results'][j].canvas.toDataURL();

            let location = new Location();
            location.ADDRESS = this.districtViewComponents['_results'][j].locationInfo.ADDRESS;
            location.CITY = this.districtViewComponents['_results'][j].locationInfo.CITY;
            location.STATE = this.districtViewComponents['_results'][j].locationInfo.STATE;
            location.ZIP = this.districtViewComponents['_results'][j].locationInfo.ZIP;
            contentDataDistrict.LOCATION = location;

            requestObj.BLOCKS.push(new ContentBlock({DATA: contentDataDistrict, ORDER: this.contentResponse.BLOCKS[i].ORDER}));
          }
        }
        break;
      default:
        break;
      }
    }

    return requestObj;
  }
}
